import React, {useState} from "react";

const FilterForm = ( {chipData} ) => {

    const [state, setState] = useState({
        data: chipData,
        elementId: 1,
        codes: 'O',
        mb: 99,
    });

    const filterItems = (val, type) => {
        switch (type) {
            case 'element':
                setState( {...state, elementId: val } );
                break;
            case 'codes':
                setState({...state, code: val });
                break;
            default:
                break;
        }
    }

    var filteredItems = chipData;
    var newState = state;
    ["elementId", "codes"].forEach( (filterBy) => {
      var filterValue = newState[filterBy];
      if (filterValue) {
        filteredItems = filteredItems.filter( (item) => {
            switch (filterBy) {
                case 'elementId':
                    return item[filterBy] === filterValue;
                    break;
                case 'codes':
                    return item[filterBy].find( code => code === filterValue);
                    break;
                default:
                    break;
            }

        });
      }
    });

    var elementArray = chipData.map( (item) => { return item });
    var codeArray = chipData.map( (item) => { return item });
    elementArray.unshift("");
    codeArray.unshift("");

    return(
        <div className="container">
        <div className="filter-form">
          {JSON.stringify(filteredItems)}
        </div>
      </div>
    )
}

export default FilterForm;